// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyCRtwZW-RF5P_CYLyT-De3us-rnk-hghH8',
  authDomain: 'scopex-v1.firebaseapp.com',
  projectId: 'scopex-v1',
  storageBucket: 'scopex-v1.appspot.com',
  messagingSenderId: '823682132403',
  appId: '1:823682132403:web:2079142529749de700c3c6',
  measurementId: 'G-JEVCRB62FE',
}

// Initialize Firebase
export const app = initializeApp(firebaseConfig)
const analytics = getAnalytics(app)
